// First we need to import axios.js
import axios, { AxiosInstance } from "axios";
import { getUserAccessToken } from '../utils/storage';
import {store} from '../appRedux/store';

export const createApiConfig = () => {
  const environmentState = store.getState().environment;
  const currentEnvironment = environmentState.currentEnvironment;
  const environments = environmentState.environments;
  const baseURL = environments[currentEnvironment]?.apiUrl;
  console.log("baseURL",baseURL);
  
  const apiConfig = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add request interceptor for authentication
  apiConfig.interceptors.request.use(
    (config) => {
      const token = getUserAccessToken();
      if (token) {
        config.headers.Authorization = `${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return apiConfig;
};

export const createApiConfigForFiles = () => {
  const environmentState = store.getState().environment;
  const currentEnvironment = environmentState.currentEnvironment;
  const environments = environmentState.environments;
  const baseURL = environments[currentEnvironment]?.apiUrl;

  const apiConfig = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  // Add request interceptor for authentication
  apiConfig.interceptors.request.use(
    (config) => {
      const token = getUserAccessToken();
      if (token) {
        config.headers.Authorization = `${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return apiConfig;
};


export const createApiConfigForCommonData = (token) => {
  // Next we make an 'instance' of it
  // const token = getUserAccessToken();

  const instance = axios.create({
    // .. where we make our configurations
    baseURL: process.env.REACT_APP_API_URL,
  });
  // Where you would set stuff like your 'Authorization' header, etc ...
  if (token) {
    instance.defaults.headers.common.Authorization = `${token}`;
  }
 
  // instance.interceptors.response.use(({ data }) => data);
  // Also add/ configure interceptors && all the other cool stuff
  return instance;
};